import React from 'react'

interface ActionButtonsProps {
  control: any
  currentUser: any
  handleOpenModal: (id: string) => void
  handleDeleteClick: (control: any) => void
  handleActivateControl: (control: any) => void
  handleDeactivateControl: (control: any) => void
  currentAuditContext: any
}

export const ActionButtons: React.FC<ActionButtonsProps> = ({
  control,
  currentUser,
  handleOpenModal,
  handleDeleteClick,
  handleActivateControl,
  handleDeactivateControl,
  currentAuditContext
}) => {
  return (
    <ul className='dropdown-menu' aria-labelledby='dropdownMenu2' style={{zIndex: 1}}>
      <li>
        <button
          className='dropdown-item text-hover-primary'
          style={{color: '#5A5A5A'}}
          type='button'
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
            handleOpenModal(control.id)
          }}
        >
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='18'
            height='18'
            viewBox='0 0 24 24'
            fill='none'
            stroke='currentColor'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
            className='icon icon-tabler icons-tabler-outline icon-tabler-eye mx-1'
          >
            <path stroke='none' d='M0 0h24v24H0z' fill='none' />
            <path d='M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0' />
            <path d='M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6' />
          </svg>{' '}
          View
        </button>
      </li>
      <li>
        {control.author === 'Custom Control' ? (
          <button
            className={`dropdown-item ${(currentUser?.role === 'Auditor' || currentAuditContext) && 'text-gray-600'}`}
            type='button'
            style={{color: '#F15363'}}
            onClick={(e) => handleDeleteClick(control)}
            disabled={currentUser?.role === 'Auditor' || currentAuditContext}
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='18'
              height='18'
              viewBox='0 0 24 24'
              fill='none'
              stroke='#F15363'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
              className='icon icon-tabler icons-tabler-outline icon-tabler-trash mx-1 mb-1'
            >
              <path stroke='none' d='M0 0h24v24H0z' fill='none' />
              <path d='M4 7l16 0' />
              <path d='M10 11l0 6' />
              <path d='M14 11l0 6' />
              <path d='M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12' />
              <path d='M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3' />
            </svg>{' '}
            Remove
          </button>
        ) : control.control_evidence_status === 'Deactivated' ? (
          <button
          className={`dropdown-item ${(currentUser?.role === 'Auditor' || currentAuditContext) && 'text-gray-600'}`}
            type='button'
            style={{color: '#5A5A5A'}}
            onClick={(e) => handleActivateControl(control)}
            disabled={currentUser?.role === 'Auditor' || currentAuditContext}
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='18'
              height='18'
              viewBox='0 0 24 24'
              fill='none'
              stroke='currentColor'
              stroke-width='2'
              stroke-linecap='round'
              stroke-linejoin='round'
              className='icon icon-tabler icons-tabler-outline icon-tabler-clock-play mx-1 mb-1'
            >
              <path stroke='none' d='M0 0h24v24H0z' fill='none' />
              <path d='M12 7v5l2 2' />
              <path d='M17 22l5 -3l-5 -3z' />
              <path d='M13.017 20.943a9 9 0 1 1 7.831 -7.292' />
            </svg>{' '}
            Activate
          </button>
        ) : (
          <button
          className={`dropdown-item ${(currentUser?.role === 'Auditor' || currentAuditContext) && 'text-gray-600'}`}
            type='button'
            style={{color: '#5A5A5A'}}
            onClick={(e) => handleDeactivateControl(control)}
            disabled={currentUser?.role === 'Auditor' || currentAuditContext}
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='18'
              height='18'
              viewBox='0 0 24 24'
              fill='none'
              stroke='currentColor'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
              className='icon icon-tabler icons-tabler-outline icon-tabler-clock-pause mx-1 mb-1'
            >
              <path stroke='none' d='M0 0h24v24H0z' fill='none' />
              <path d='M20.942 13.018a9 9 0 1 0 -7.909 7.922' />
              <path d='M12 7v5l2 2' />
              <path d='M17 17v5' />
              <path d='M21 17v5' />
            </svg>{' '}
            Deactivate
          </button>
        )}
      </li>
    </ul>
  )
}
